import styled from 'styled-components';
import { motion } from 'framer-motion';
import { H2, P } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Background = styled.div`
  background-color: ${th('colors.turquoise')};
`;

export const StyledHomeCountry = styled.div`
  padding: 20px;
  padding-bottom: 80px;
  position: relative;
  background-color: ${th('colors.black')};
  z-index: 2;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    padding-top: 20px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding: 100px;
  }
`;

export const Title = styled(H2)`
  font-family: ${th('fonts.headings')};
  font-weight: normal;
  line-height: 1;

  > br {
    display: none;
  }

  @media ${sizes.tabletPortrait} {
    font-size: 60px;

    > br {
      display: block;
    }
  }

  @media ${sizes.desktop} {
    font-size: 90px;
  }

  @media ${sizes.extraLargeDesktop} {
    font-size: 120px;
  }
`;

export const Highlight = styled.span`
  color: ${th('colors.turquoise')};
`;

export const Description = styled(P)`
  margin-top: 40px;
  font-size: 18px;

  @media ${sizes.mobileMedium} {
    padding-right: 18%;
  }

  @media ${sizes.mobileLarge} {
    padding-right: 38%;
  }

  @media ${sizes.tabletPortrait} {
    padding-right: 0;
    max-width: 470px;
  }

  @media ${sizes.tabletLandscape} {
    max-width: 490px;
  }

  @media ${sizes.desktop} {
    font-size: 20px;
    max-width: 540px;
  }

  @media ${sizes.extraLargeDesktop} {
    max-width: 720px;
    font-size: 28px;
  }
`;

export const UnderlineContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Underline = styled(motion.span)`
  width: 100%;
  padding-bottom: 5px;
  border-bottom: 2px solid ${th('colors.turquoise')};
  white-space: nowrap;
  transform-origin: left;
`;

export const FeatherImg = styled.img`
  position: absolute;
  bottom: -30px;
  right: 10px;
  width: 60%;

  @media ${sizes.mobileMedium} {
    bottom: -50px;
  }

  @media ${sizes.tabletPortrait} {
    bottom: -100px;
    right: 10px;
    width: 38%;
  }

  @media ${sizes.desktop} {
    bottom: -150px;
  }
`;
